import React from 'react';
import { useLocation } from 'react-router';
import _get from 'lodash/get';

import { EMPTY_OBJECT, EMPTY_STRING, FormBuilder } from 'commons-ui';

import useCreate from './useCreateBulk';
import { FORM_FIELD_CONFIG_CREATE, FORM_LAYOUT_CONFIG_CREATE, validationSchemaCreate } from '../../utils/bulkFormConfig';

const CreateBulk: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	const location = useLocation();
	const rowData = _get(location, ['state', 'rowData'], EMPTY_OBJECT);
	const cid = _get(rowData, ['_id'], EMPTY_STRING);
	data.cid = cid;

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit(rowData)}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			validationSchema={validationSchemaCreate}
			fieldConfig={FORM_FIELD_CONFIG_CREATE}
			layoutConfig={FORM_LAYOUT_CONFIG_CREATE}
		/>
	);
};

export default CreateBulk;
